import { createFileRoute, Outlet, redirect } from '@tanstack/react-router';
import { AppShell } from '../../components/layout/AppShell.js';
import { useAuth } from '../../lib/auth.js';
import { api } from '../../lib/api.js';

export const Route = createFileRoute('/_auth')({
  // Server-side check on load: if no session cookie, redirect
  beforeLoad: async () => {
    try {
      await api.get('/api/auth/me');
    } catch {
      throw redirect({ to: '/login' });
    }
  },
  component: AuthLayout,
});

function AuthLayout() {
  const { isLoading, user } = useAuth();

  if (isLoading) {
    return (
      <div className="min-h-screen flex items-center justify-center">
        <div className="text-secondary text-sm">Loading…</div>
      </div>
    );
  }

  if (!user) {
    return null;
  }

  return (
    <AppShell>
      <Outlet />
    </AppShell>
  );
}
